import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Pod.css';
import Box from '../../hoc/Box/Box';
import api from '../../axios-local-api';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { FaExclamationCircle, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Error from '../../components/UI/Error/Error';
import { FaDownload } from 'react-icons/fa';
import ClaimPod from '../ClaimPod/ClaimPod';
import Modal from '../../components/UI/Modal/Modal';
import { history } from '../..';
import { EquipmentTypes } from '../../shared/common';

export class Pod extends Component {
  constructor(props) {
    super(props);
    // console.log("pod.constructor");
    this.state = {
      claimed: props.data.claimed,
      showClaimPopUp: false,
      highlightSelection: false,
      isClicked: false,
    };
  }
  componentDidMount() {}
  componentWillUpdate() {}
  componentDidUpdate() {}

  onClick = () => {
    if (this.props.data.claimed === false) {
      this.setState({
        showClaimPopUp: !this.state.claimed,
        highlightSelection: false,
        isClicked: false,
      });
      return;
    }
    this.setState({
      showClaimPopUp: !this.state.claimed,
      highlightSelection: true,
      isClicked: true,
    });
    this.props.data.setEquipmentSelection({
      routerId: this.props.data.routerId,
      podId: this.props.data.id,
      serialNumber: this.props.data.serialNumber,
      nickname: this.props.data.nickname,
      defaultName: this.props.data.defaultName,
      ip: this.props.data.ip || 'N/A',
      type: EquipmentTypes.Pod,
      claimed: this.props.data.claimed,
      podConnectionState: this.props.data.connectionState,
      displayAllEquipment: false,
      didClick: true,
    });
    history.replace('/overview');
    // this.props.setLocatePod({ pSerial: this.props.data.serialNumber, mode: false });
    // this.props.locateAllPods()
  };

  changeStatus = () => {
    this.setState({
      isClicked: false,
    });
  };

  handleClaimPod = () => {
    let props = this.props;
    // console.log("handle claim Pod", props);
    let claimPodPromise = new Promise(function (resolve, reject) {
      let result = props.onClaimPod(props.data.id, props.data.macAddress);
      // console.log("result", result);
      resolve();
    });
    claimPodPromise.then(() => {
      // console.log("checking change pod success", props);
    });

    this.setState({
      showClaimPopUp: false,
    });
  };

  modalCancelHandler = () => {
    this.setState({
      showClaimPopUp: false,
    });
  };

  handleReclaimModalCancel = () => {
    this.setState({
      showReclaimPopUp: false,
    });
  };

  showReclaimPopUp = () => {
    // console.log("showReclaimPopUp");
    this.setState({
      showReclaimModal: true,
    });
  };

  render() {
    let claimPod;

    if (!this.state.claimed) {
      let podTitle = 'Claim EXTENDER';
      let podMessage =
        'EXTENDER - ' + this.props.data.id + ' is currently unclaimed. Claim now ?';
      let podBtnText = 'Claim';
      let claim = true;

      claimPod = (
        <ClaimPod
          podTitle={podTitle}
          podMessage={podMessage}
          podBtnText={podBtnText}
          onCancel={this.modalCancelHandler}
          onSuccess={this.handleClaimPod}
          claim={claim}
        ></ClaimPod>
      );
    }

    let equips;
    if (this.props.loading) {
      return <Spinner />;
    } else {
      let subPods = [];
      if (this.props.data.pods !== undefined) {
        subPods = this.props.data.pods.map((subPod) => {
          if (
            this.props.selectedEquipment &&
            this.props.selectedEquipment.podId === subPod.id
          ) {
            return (
              <div
                className={[classes.SubPod, classes.SelectedBgColor].join(' ')}
              >
                <Pod
                  data={subPod}
                  podTimer={this.props.podTimer}
                  rebootPodId={this.props.rebootPodId}
                  checkingWan={this.props.checkingWan}
                />
              </div>
            );
          } else {
            return (
              <div className={classes.SubPod}>
                <Pod
                  data={subPod}
                  podTimer={this.props.podTimer}
                  rebootPodId={this.props.rebootPodId}
                  checkingWan={this.props.checkingWan}
                />
              </div>
            );
          }
        });
      }

      let connectionState;
      // console.log('1st Condition ::::', this.props.checkingWan);
      // console.log('2nd Condition ::::', this.props.podTimer);
      // console.log('2nd Condition :::', this.props.rebootPodId);
      // console.log('2nd Condition :::', this.props.data.id)
      // console.log('2nd Condition ::: ', this.props.selectedEquipment.podId);
      // console.log('3rd Condition :::', this.props.data.connectionState);
      if (
        this.props.checkingWan ||
        (this.props.podTimer &&
          this.props.rebootPodId === this.props.data.id) ||
        (this.props.data.connectionState !== undefined &&
          this.props.data.connectionState === 'disconnected')
      ) {
        connectionState = <FaExclamationCircle color={'red'} />;
      }

      if (
        !this.state.claimed ||
        (this.props.data.freqBand &&
          (this.props.data.freqBand.includes('2.4G') ||
            this.props.data.freqBand.includes('2.4g')))
      ) {
        connectionState = <FaExclamationCircle color={'red'} />;
      }

      let connectedDeviceCount, connectedDeviceCnt;
      // console.log('pod info :::', this.props, this.props.wan);
      if (
        this.props.checkingWan ||
        (this.props.podTimer && this.props.rebootPodId === this.props.data.id)
      ) {
        connectedDeviceCnt = 0;
      } else {
        connectedDeviceCnt = this.props.data.connectedDeviceCount;
      }
      if (connectedDeviceCnt !== undefined) {
        connectedDeviceCount = (
          <div id="PodConnectedCount">
            connected Devices {connectedDeviceCnt}
          </div>
        );
      }

      let podTitle = this.state.claimed ? "Extender" : 'Unclaimed Extender';
      let nickname;
      if (this.state.claimed) {
        nickname = this.props.data.nickname || this.props.data.defaultName;
      } else {
        nickname = this.props.data.id;
      }

      let equipmentClass = classes.Equipment;
      if (this.state.highlightSelection) {
        equipmentClass += ' ' + classes.EquipmentSelected;
      }
      let podHtml;
      if (
        this.props.selectedEquipment &&
        this.props.selectedEquipment.podId === this.props.data.id
      ) {
        podHtml = (
          <div
            style={{ cursor: 'pointer' }}
            className={[classes.Equipment, classes.SelectedBgColor].join(' ')}
            onClick={this.onClick}
          >
            <div>
              <b>{podTitle}</b>
              {connectionState}
            </div>
            <div style={{ whiteSpace: 'pre' }}>{nickname}</div>
            {connectedDeviceCount}
          </div>
        );
      } else {
        podHtml = (
          <div
            style={{
              cursor: 'pointer',
              width: '210px',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
            }}
            id="leftTrailPod"
            className={[classes.Equipment]}
            onClick={this.onClick}
          >
            <div>
              {' '}
              <b>{podTitle}</b> {connectionState}
            </div>
            <div id="PodNickName" style={{ whiteSpace: 'pre-wrap' }}>
              {nickname}
            </div>
            {connectedDeviceCount}
          </div>
        );
      }

      return (
        <Box>
          <div className={classes.Spacer} />
          {podHtml}
          {subPods}
          <Modal
            show={this.state.showClaimPopUp}
            modalClosed={this.modalCancelHandler}
          >
            {claimPod}
          </Modal>
          <Modal
            show={this.state.showErrorModal}
            modalClosed={this.modalErrorHandler}
          >
            <Error />
          </Modal>
          <Modal
            show={this.state.showSuccessModal}
            modalClosed={this.modalSuccessHandler}
          >
            <Success />
          </Modal>
        </Box>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.settings.loading,
    loaded: state.settings.loaded,
    account: state.settings.account,
    success: state.equipment.success,
    error: state.equipment.error,
    equipment: state.equipment,
    wan: state.wan,
    checkingWan: state.wan.checkingWan,
    podTimer: state.wan.podTimer,
    rebootPodId: state.wan.rebootPodId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClaimPod: (serialNumber, macAddress) => dispatch(actions.claimPod(serialNumber, macAddress)),
    setLocatePod: (payload) => {
      dispatch(actions.setLocatePod(payload));
    },
    locateAllPods: () => {
      dispatch(actions.locateAllPods());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Pod, api));
